import React, { useRef } from 'react';
import { AssetUrls } from 'config/assets';
import { FeedCardRef } from 'types/interfaces/followingFeed';

const CARD_BACK_DATA_URI =
  "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='223' height='311' viewBox='0 0 223 311'%3E%3Crect width='223' height='311' rx='12' fill='%231a1a2e'/%3E%3Crect x='8' y='8' width='207' height='295' rx='8' fill='none' stroke='%236F51E4' stroke-width='2' opacity='0.4'/%3E%3Ctext x='111.5' y='165' text-anchor='middle' fill='%236F51E4' font-size='48' opacity='0.5'%3E%E2%9C%A6%3C/text%3E%3C/svg%3E";

interface CardThumbnailProps {
  card: FeedCardRef;
  index: number;
  className?: string;
  onClick?: () => void;
  alt?: string;
}

export const CardThumbnail: React.FC<CardThumbnailProps> = ({
  card,
  index,
  className,
  onClick,
  alt,
}) => {
  const fallbackStepRef = useRef<Map<number, number>>(new Map());

  const handleError = (e: React.SyntheticEvent<HTMLImageElement>) => {
    const step = fallbackStepRef.current.get(index) ?? 0;
    fallbackStepRef.current.set(index, step + 1);

    const backendFallbacks = card.normal_fallbacks ?? [];
    const cdnFallbacks = card.scryfallId
      ? [
          AssetUrls.cards.getCardImage(card.scryfallId, 'normal'),
          AssetUrls.cards.getCardImage(card.scryfallId, 'small'),
          AssetUrls.cards.getCardImage(card.scryfallId, 'large'),
        ]
      : [];

    const initialUrl = card.imageUrl;
    const chain = [...backendFallbacks, ...cdnFallbacks].filter(
      (url) => url && url !== initialUrl,
    );

    if (step < chain.length) {
      e.currentTarget.src = chain[step];
      return;
    }

    e.currentTarget.src = CARD_BACK_DATA_URI;
  };

  return (
    <img
      className={className}
      src={card.imageUrl || CARD_BACK_DATA_URI}
      alt={alt ?? card.cardName}
      onError={handleError}
      onClick={onClick}
      loading="lazy"
    />
  );
};

export default CardThumbnail;
